import React, { useState } from 'react';
import Snake from 'react-simple-snake';
import { GetSingleJoke } from './apiClient'

export function SnakeGame() {
    const [joke, setJoke] = useState('');

    const getJoke = async () => {
        const j = await GetSingleJoke();
        setJoke(j.joke);
    }

    React.useEffect(() => {
        getJoke();
      }, []);

    return (
        <div>
            <Snake />
            <br />
            <br />
            <br />
            <center><h3>{joke}</h3></center>
        </div>
    );
}